import React, { Component } from "react";
import App from "../../App";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiEye, FaLongArrowAltLeft } from "react-icons/all";
import Pagination from "react-js-pagination";
import { withRouter, Link } from "react-router-dom";
import "../../assets/scss/order-list.scss";
import { getPaginatedList, postData } from "../../services/baseServices";
import { getFormattedDate, humanize } from "../../helper/utils";
import Loader from 'react-loader';
import { toast } from "react-toastify";
import _ from 'lodash'
import { DEBOUNCE_TIME } from "../../helper/env"
import ConfirmationModal from "../common/Modal";

class BackwardChallanForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			orderList: [],
            returnList: [],
			isLoading: false,
            per_page: 25,
			activePage1: 1,
			page1: 1,
            total_data1: 0,
            total_data2: 0,
			activePage2: 1,
			page2: 1,
            includedOrderIds: [],
            includedReturnIds: [],
            allOrderSeleted: {
                '1': false 
            },
            allReturnOrderSeleted: {
                '1': false 
            }
		};
	}

	getOrderData() {
		getPaginatedList('return_challans/available_orders', {order_type: 'CustomerOrder', per_page: this.state.per_page})
			.then((res) => {
				this.setState({
					orderList: res?.data?.data,
					total_data1: res.headers["x-total"],
				});
			})
			.catch((message) => {toast.error(message)});
	}

    getReturnData() {
        getPaginatedList('return_challans/available_orders', {order_type: 'ReturnCustomerOrder', per_page: this.state.per_page})
        .then((res) => {
            this.setState({
                returnList: res?.data?.data,
                total_data2: res.headers["x-total"],
            });
        })
        .catch((message) => {toast.error(message)});
    }

    componentDidMount(){
        this.getOrderData()
        this.getReturnData()
    }

	handlePageChange1 = (pageNumber) => {
		this.setState(
			{ page1: pageNumber, activePage1: pageNumber},
			() => {
				this.getOrderData();
			}
		);
	};


	handlePageChange2 = (pageNumber) => {
		this.setState(
			{ page2: pageNumber, activePage2: pageNumber},
			() => {
				this.getReturnData();
			}
		);
	};

    setAllOrderMark = (all) => {
        if(all) {
          this.setState({ allOrderSeleted : {...this.state.allOrderSeleted, [this.state.page]: true}})
          const xxx = this.state.orderList?.map(item=>+item.order_id)
          let ids = [...this.state.includedOrderIds]
          ids = ids?.filter(i => !xxx.includes(i))
          ids = ids.concat(xxx)
          this.setState({ includedOrderIds : ids})
        } else {
            this.setState({ allOrderSeleted : {...this.state.allOrderSeleted, [this.state.page]: false}})
            let selectedIds = [...this.state.includedOrderIds]
            const orderIds = this.state.orderList?.map(i => i.order_id)
            selectedIds = selectedIds?.filter(i => !orderIds.includes(i))
            this.setState({ includedOrderIds : selectedIds})
        }
      }

    selectOrder = (orderId) => {
        
        let ids = [...this.state.includedOrderIds];
        if (ids?.includes(orderId)) {
          ids = ids.filter(function (e) {
            return e !== orderId
          });
        } else {
          ids.push(+orderId);
            
        }
        this.setState({ includedOrderIds : ids})
      }

      setAllReturnMark = (all) => {
        if(all) {
          this.setState({ allReturnOrderSeleted : {...this.state.allReturnOrderSeleted, [this.state.page]: true}})
          const xxx = this.state.returnList?.map(item=>+item.id)
          let ids = [...this.state.includedReturnIds]
          ids = ids?.filter(i => !xxx.includes(i))
          ids = ids.concat(xxx)
          this.setState({ includedReturnIds : ids})
        } else {
            this.setState({ allReturnOrderSeleted : {...this.state.allReturnOrderSeleted, [this.state.page]: false}})
            let selectedIds = [...this.state.includedReturnIds]
            const orderIds = this.state.returnList?.map(i => i.id)
            selectedIds = selectedIds?.filter(i => !orderIds.includes(i))
            this.setState({ includedReturnIds : selectedIds})
        }
      }

    selectReturnOrder = (orderId) => {
        let ids = [...this.state.includedReturnIds];
        if (ids?.includes(orderId)) {
          ids = ids.filter(function (e) {
            return e !== orderId
          });
        } else {
          ids.push(+orderId);
            
        }
        this.setState({ includedReturnIds : ids})
      }
    
    submitChallanForm = () => {
        const params = {
            returned_order_ids : this.state.includedReturnIds,
            cancelled_order_ids: this.state.includedOrderIds
        }
        postData("return_challans",params)
        .then(res => {
          if(res.success) {
            this.props.history.push(`/return-challan/list`);
            toast.success("Challan has been created successfully.");
          }
          else {
            toast.error(res.message);
          }
        })
        .catch(errMsg => {
          toast.error(errMsg);
        }); 
    }


  debouncedOnSubmitChallan = _.debounce(()=>{
    this.submitChallanForm()
  }, DEBOUNCE_TIME);

  handleWithDebounceSubmitForm = () => {
    this.debouncedOnSubmitChallan();
  }

	render() {
		return (
			<App layout="">
				<div className="main-content">
					<div className="page-header">
						<h2 className="page-title">Return Challan Creation Form</h2>
                        <div className="ml-auto" style={{display: "flex"}}>
                          <Link to={'/return-challan/list'} className="btn btn-sm btn-link"><FaLongArrowAltLeft/> Back to Return Challan list</Link>
                        </div>
					</div>
                    {
                    
					<Loader loaded={!this.state.isLoading}>
                        <div className="card-block">
                            <div className="block-body">
                                {
                                    
                                    <div className="block-body d-flex justify-content-between">
                                         <div>
                                            Total Orders: <strong>{this.state.total_data1}</strong>
                                            <br/>
                                            Total Return Requests: <strong>{this.state.total_data2}</strong>
                                            <br/>
                                            Selected Orders: <strong>{this.state.includedOrderIds?.length}</strong>
                                            <br/>
                                            Selected Return Requests: <strong>{this.state.includedReturnIds?.length}</strong>
                                        </div>
                                        <div>
                                            {
                                                (this.state.includedOrderIds?.length > 0 || this.state.includedReturnIds?.length > 0) ?
                                                <OverlayTrigger
                                                    key="view"
                                                    placement="top"
                                                    overlay={
                                                    <Tooltip id={`tooltip-view`}>Create Return Challan</Tooltip>
                                                    }
                                                >
                                                    <ConfirmationModal 
                                                        customBtn = {true}
                                                        btnText = "Create Return Challan"
                                                        variant = "primary"
                                                        title="Create Return Challan" 
                                                        body="Are you sure to create the return challan?" 
                                                        handleAction={() =>this.debouncedOnSubmitChallan()}/>
                                                </OverlayTrigger>
                                                :
                                                <Button disabled size="sm">Create Return Challan</Button>
                                            }
                                            
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.orderList?.length > 0 &&
                                    <>

                                <h4>Cancelled Orders</h4>
                                <table className="order-table table table-striped">
                                    <thead>
                                        <tr>
                                            <th>
                                            {
                                            !this.state.allOrderSeleted?.[this.state.page] ?
                                            <span><input name="select-all" id="select-all" type="checkbox" onChange={()=>this.setAllOrderMark(true)}/>  Select All</span>
                                            : <span><input name="unselect-all" type="checkbox" id="unselect-all" checked={true} onChange={()=> this.setAllOrderMark(false)}/>  Unselect All</span>
                                            }
                                            </th>
                                            <th>Order No</th>
                                            <th>Order Date</th>
                                            <th>Shipping Type</th>
                                            <th>Amount</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.orderList?.length > 0 ? (
                                            this.state.orderList?.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            <input 
                                                                custom
                                                                inline
                                                                type="checkbox" 
                                                                id={`custom_checkbox_${index}`} 
                                                                className="input"
                                                                value={item.order_id} 
                                                                name="select_order" 
                                                                checked={this.state.includedOrderIds?.includes((item.order_id))}
                                                                onChange={()=>this.selectOrder(item.order_id)}/>
                                                        </td>
                                                        <td>{item.order_id}</td>
                                                        <td>
                                                            <div className="order-item">
                                                                {getFormattedDate(item.date,"LT, Do, MMMM, YYYY")}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="order-item">
                                                                {item.shipping_type}
                                                            </div>
                                                        </td>
                                                    
                                                        <td>
                                                            <div className="order-item">{item.price}</div>
                                                        </td>
                                                        <td>
                                                            <div className="order-item">{humanize(item.status)}</div>
                                                        </td>
                                                        <td style={{ width: "150px" }} className={"nowrap"}>
                                                            <div className="btn-group">
                                                                <OverlayTrigger
                                                                    key="view"
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id={`tooltip-view`}>View</Tooltip>
                                                                    }
                                                                >
                                                                    <Link
                                                                        to={`/customerOrder/details/${item.order_id}`}
                                                                        className="btn btn-sm btn-default"
                                                                    >
                                                                        <FiEye />
                                                                    </Link>
                                                                </OverlayTrigger>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={7} className="text-center">
                                                    <h5>No Order Found</h5>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <div className="mt-3">
                                    <Pagination
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        activePage={this.state.activePage1}
                                        itemsCountPerPage={this.state.per_page}
                                        totalItemsCount={this.state.total_data1}
                                        pageRangeDisplayed={10}
                                        onChange={this.handlePageChange1.bind(this)}
                                    />
                                </div>
                                    </>
                                }
                                
                            </div>
                            {
                                this.state.returnList?.length > 0 &&
                                <div className="block-body">
                                    <h4>Return Requests</h4>
                                    <table className="order-table table table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                {
                                                !this.state.allReturnOrderSeleted?.[this.state.page] ?
                                                <span><input name="select-all" id="select-all" type="checkbox" onChange={()=>this.setAllReturnMark(true)}/>  Select All</span>
                                                : <span><input name="unselect-all" type="checkbox" id="unselect-all" checked={true} onChange={()=> this.setAllReturnMark(false)}/>  Unselect All</span>
                                                }
                                                </th>
                                                <th>Return Request No</th>
                                                <th>Order No</th>
                                                <th>Created Date</th>
                                                <th>Initiated By</th>
                                                <th>Return Type</th>
                                                <th>Price</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.returnList?.length > 0 ? (
                                                this.state.returnList?.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                <input 
                                                                    custom
                                                                    inline
                                                                    type="checkbox" 
                                                                    id={`custom_checkbox_${index}`} 
                                                                    className="input"
                                                                    value={item.id} 
                                                                    name="select_order" 
                                                                    checked={this.state.includedReturnIds?.includes((item.id))}
                                                                    onChange={()=>this.selectReturnOrder(item.id)}/>
                                                            </td>
                                                            <td><Link to={`/return-order/details/${item.id}`}>{item.id}</Link></td>
                                                            <td><Link to={`/customerOrder/details/${item.order_id || '_'}`}>{item.order_id || '_'}</Link></td>
                                                            <td>
                                                                <div className="order-item">
                                                                    {getFormattedDate(item.created_at,"LT, Do, MMMM, YYYY")}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="order-item">
                                                                    {item.initiated_by}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="order-item">
                                                                    {item.return_type}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="order-item">{item.price}</div>
                                                            </td>
                                                            <td>
                                                                <div className="order-item">
                                                                    {humanize(item.return_status)}
                                                                </div>
                                                            </td>
                                                            <td className={"nowrap"}>
                                                                <div className="btn-group">
                                                                    <OverlayTrigger
                                                                        key="view"
                                                                        placement="top"
                                                                        overlay={
                                                                            <Tooltip id={`tooltip-view`}>View</Tooltip>
                                                                        }
                                                                    >
                                                                        <Link
                                                                            to={`/return-order/details/${item.id}`}
                                                                            className="btn btn-sm btn-default"
                                                                        >
                                                                            <FiEye />
                                                                        </Link>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={7} className="text-center">
                                                        <h5>No Return Requests Found</h5>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <div className="mt-3">
                                        <Pagination
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            activePage={this.state.activePage2}
                                            itemsCountPerPage={this.state.per_page}
                                            totalItemsCount={this.state.total_data2}
                                            pageRangeDisplayed={10}
                                            onChange={this.handlePageChange2.bind(this)}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                    </Loader>
                    }
				</div>
			</App>
		);
	}
}

export default withRouter(BackwardChallanForm);
